export type EventMode =
  | "quiet"
  | "preparation"
  | "active"
  | "follow-through"
  | "archive";

export interface EventWindows {
  preparationStartsAt: string;
  activeStartsAt: string;
  activeEndsAt: string;
  followThroughEndsAt: string;
}

export function determineEventMode(now: Date, windows: EventWindows): EventMode {
  const timestamp = now.getTime();
  const preparation = Date.parse(windows.preparationStartsAt);
  const activeStart = Date.parse(windows.activeStartsAt);
  const activeEnd = Date.parse(windows.activeEndsAt);
  const followThroughEnd = Date.parse(windows.followThroughEndsAt);

  if ([preparation, activeStart, activeEnd, followThroughEnd].some(Number.isNaN)) {
    throw new Error("Event windows must contain valid ISO timestamps.");
  }
  if (!(preparation <= activeStart && activeStart < activeEnd && activeEnd < followThroughEnd)) {
    throw new Error("Event windows must be chronological.");
  }

  if (timestamp < preparation) return "quiet";
  if (timestamp < activeStart) return "preparation";
  if (timestamp < activeEnd) return "active";
  if (timestamp < followThroughEnd) return "follow-through";
  return "archive";
}
